import Enumerable from './Enumerable';
export default class MapUtils {
    static enumerableKeys(map) {
        return new Enumerable(map.keys());
    }
    static enumerableValues(map) {
        return new Enumerable(map.values());
    }
    static toEnumerable(map) {
        return new Enumerable(map);
    }
}
//# sourceMappingURL=MapUtils.js.map